// extracted by mini-css-extract-plugin
export var errorsContainer = "_sz-1";
export var link = "_sz-0";